import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { DeviantRekenmoduleVoucherEndpointService } from './deviant-rekenmodule-voucher.endpoint.service';

export type DeviantRekenmoduleVoucher = {
  voucherCode: string;
  validUntil: string;
};

@Service()
export class DeviantRekenmoduleVoucherService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(DeviantRekenmoduleVoucherEndpointService);

  fetchVoucher() {
    const endpoint = this.#endpoints.getVoucher();

    return this.#http.get<DeviantRekenmoduleVoucher>(endpoint);
  }
}
